<template>
  <div class="subscription">
    <SubscriptionForm />
  </div>
</template>
<script>
import SubscriptionForm from "./Subscription/SubscriptionForm.vue";
export default {
  components: {
    SubscriptionForm,
  },
};
</script>
<style scoped>
.subscription {
  overflow: auto;
  height: 100%;
}
@media screen and (min-width: 394px) {
  .subscription {
    overflow: auto;
    height: 100%;
  }
}
</style>
